import { AirTableAdRecord } from '../../../../src/shared'

export const REQUEST_TEMPLATE_MESSAGE = 'Hold on a moment...'
export const REQUEST_TEMPLATE_DESCRIPTION = 'We’re currently checking your request status. This may take a few seconds.'
export const CREATIVE_TOOLKIT_LIMIT_REACHED_TITLE = 'Limit Reached'
export const CREATIVE_TOOLKIT_LIMIT_REACHED_BODY = `You've reached your monthly limit for the Creative Toolkit. Please check back next month.`

export enum ExpertSpeciality {
  Ads = 'Ad Collection',
  Emails = 'Email Collection',
  Landers = 'Lander Collection',
}

export type BoardCollectionDataProps = {
  collections: ExpertProductType[]
}

export type ExpertProductType = {
  name: string
  atId: string
  image?: string | null
  speciality: ('Ads' | 'Emails' | 'Landers')[]
  adTemplates?: AirTableAdRecord[]
  totalAdCount?: number
  totalEmailCount?: number
}

export const defaultUseQueryRefetchOptions = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
}

export const termsAndPoliciesLink =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=92309a15-f8de-4691-a28e-23fd10a6ea97'
export const privacyPolicyLink =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=6c0c8944-9d66-45cd-8675-d6ec08e36e2a'
